import React, { useEffect } from 'react';
import SectionTop from '../layout/SectionTop';
import Why2Bytes from '../layout/Why2Bytes';
import SectionBottom from '../layout/SectionBottom';
import Services from '../components/Services'

import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';

function Content(props) {
    const { t, i18n } = useTranslation();
    const pt = (v) => parse(i18n.t(v));

    useEffect(() => {
        $(window).trigger('scroll');
        $(window).scrollTop(0);
    }, []);
    return (
        <>
            <section className="section_discript">
                <div className="inner">
                    <strong className="title">
                        {pt('QA_1')}
                        {/* 2bytes QA의 핵심 <br className="visible_sm" />역량 3가지 */}
                    </strong>

                  <div className="cont" style={{ marginTop: '0px' }}>
                    <div style={{
                      display: 'flex',
                      gap: '31px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexWrap: 'wrap'
                    }}>
                      <img
                        src="/static/img/qa/tencent.jpg"
                        alt="Tencent"
                        style={{ height: '60px', maxWidth: '100%' }}
                      />
                      <img
                        src="/static/img/qa/wetest.jpg"
                        alt="WeTest"
                        style={{ height: '31px', maxWidth: '100%' }}
                      />
                    </div>
                  </div>

                    <div className="step_box">
                        <dl>
                            <dt>
                                {pt('QA_2')}
                                {/* <span className="num">1</span> 대표 IT 기업 출신의 QA 전문가 */}
                            </dt>
                            <dd>
                                {pt('QA_3')}
                                {/* 검은사막, 리니지2레볼루션, 라그나로크 등 AAA급 MMORPG QA 경험을
                                보유한 실무진이 직접 QA를 전담합니다. 대형개발사의 노하우 그대로
                                최적의 QA PLAN을 제안합니다. */}
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                {pt('QA_4')}
                                {/* <span className="num">2</span> 다양한 플랫폼에서의 경험 */}
                            </dt>
                            <dd>
                                {pt('QA_5')}
                                {/* Mobile 뿐만 아니라 PC, Web 기반 게임까지 다양한 플랫폼의 QA를
                                제공합니다. <br />
                                17년 경력의 QA 전문가가 Plan 감수 및 진행을 리드합니다. */}
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                {pt('QA_6')}
                                {/* <span className="num">3</span> 마켓별 정책 대응 및 피쳐드 전략 */}
                            </dt>
                            <dd>
                                {pt('QA_7')}
                                {/* Google, Apple 등 주요 마켓 검수를 위한 최적화 방안과 Featured
                                Know-How를 제공합니다. */}
                            </dd>
                        </dl>
                    </div>
                </div>
            </section>

            <section className="section_contents">
                <div className="inner">
                    <div className="h_title_box">
                        <h3 className="h_title">
                            {pt('QA_WeTest_Title')}
                        </h3>
                    </div>

                    <div className="cont">
                        <div style={{ display: 'flex', gap: '26px', marginBottom: '40px', flexWrap: 'wrap' }}>
                            {/* 기능 QA */}
                            <div style={{ flex: '1', minWidth: '300px' }}>
                                <div style={{
                                    backgroundColor: '#1dd1d3',
                                    color: 'white',
                                    padding: '13px 0',
                                    textAlign: 'center',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    marginBottom: '17px'
                                }}>
                                    {pt('QA_Function_QA_Title')}
                                </div>
                                <div style={{ display: 'flex', gap: '17px' }}>
                                    <div style={{
                                        flex: '1',
                                        backgroundColor: '#f5f5fb',
                                        border: '1px solid #e0e0e0'
                                    }}>
                                        <div style={{
                                            backgroundColor: '#743fa3',
                                            color: 'white',
                                            padding: '13px 0',
                                            textAlign: 'center',
                                            fontSize: '20px',
                                            fontWeight: 'bold'
                                        }}>
                                            {pt('QA_Function_Test_Title')}
                                        </div>
                                        <div style={{ padding: '20px', fontSize: '17px', lineHeight: '1.5', color: '#444' }}>
                                            {pt('QA_Function_Test_Content').split('\n').map((line, i) => (
                                                <div key={i}>{line}</div>
                                            ))}
                                        </div>
                                    </div>
                                    <div style={{
                                        flex: '1',
                                        backgroundColor: '#f5f5fb',
                                        border: '1px solid #e0e0e0'
                                    }}>
                                        <div style={{
                                            backgroundColor: '#743fa3',
                                            color: 'white',
                                            padding: '13px 0',
                                            textAlign: 'center',
                                            fontSize: '20px',
                                            fontWeight: 'bold'
                                        }}>
                                            {pt('QA_Compatibility_Test_Title')}
                                        </div>
                                        <div style={{ padding: '20px', fontSize: '17px', lineHeight: '1.5', color: '#444' }}>
                                            {pt('QA_Compatibility_Test_Content').split('\n').map((line, i) => (
                                                <div key={i}>{line}</div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 성능 QA */}
                            <div style={{ flex: '1', minWidth: '300px' }}>
                                <div style={{
                                    backgroundColor: '#1dd1d3',
                                    color: 'white',
                                    padding: '13px 0',
                                    textAlign: 'center',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    marginBottom: '17px'
                                }}>
                                    {pt('QA_Performance_QA_Title')}
                                </div>
                                <div style={{ display: 'flex', gap: '17px' }}>
                                    <div style={{
                                        flex: '1',
                                        backgroundColor: '#f5f5fb',
                                        border: '1px solid #e0e0e0'
                                    }}>
                                        <div style={{
                                            backgroundColor: '#743fa3',
                                            color: 'white',
                                            padding: '13px 0',
                                            textAlign: 'center',
                                            fontSize: '20px',
                                            fontWeight: 'bold'
                                        }}>
                                            {pt('QA_Client_Performance_Test_Title')}
                                        </div>
                                        <div style={{ padding: '20px', fontSize: '17px', lineHeight: '1.5', color: '#444' }}>
                                            {pt('QA_Client_Performance_Test_Content').split('\n').map((line, i) => (
                                                <div key={i}>{line}</div>
                                            ))}
                                        </div>
                                    </div>
                                    <div style={{
                                        flex: '1',
                                        backgroundColor: '#f5f5fb',
                                        border: '1px solid #e0e0e0'
                                    }}>
                                        <div style={{
                                            backgroundColor: '#743fa3',
                                            color: 'white',
                                            padding: '13px 0',
                                            textAlign: 'center',
                                            fontSize: '20px',
                                            fontWeight: 'bold'
                                        }}>
                                            {pt('QA_APM_Title')}
                                        </div>
                                        <div style={{ padding: '20px', fontSize: '17px', lineHeight: '1.5', color: '#444' }}>
                                            {pt('QA_APM_Content').split('\n').map((line, i) => (
                                                <div key={i}>{line}</div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={{
                            fontSize: '24px',
                            color: '#444',
                            textAlign: 'left',
                            marginTop: '20px'
                        }}>
                            {pt('QA_Note')}
                        </div>
                    </div>
                </div>
            </section>

            <section className="section_contents">
                <div className="inner">
                    <div className="h_title_box">
                        <h3 className="h_title">
                            {pt('QA_Features_Title')}
                        </h3>
                    </div>

                    <div className="cont">
                        {/* 특징 태그 */}
                        <div className="qa-feature-tags-mobile-hidden" style={{ 
                            display: 'flex', 
                            gap: '0', 
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginBottom: '80px',
                            flexWrap: 'wrap'
                        }}>
                            {[
                                'QA_Feature_Tag1',
                                'QA_Feature_Tag2',
                                'QA_Feature_Tag3',
                                'QA_Feature_Tag4',
                                'QA_Feature_Tag5',
                                'QA_Feature_Tag6'
                            ].map((tag, index) => (
                                <React.Fragment key={index}>
                                    <div style={{
                                        width: '120px',
                                        height: '120px',
                                        borderRadius: '50%',
                                        backgroundColor: '#f5f5fb',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#743fa3',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        letterSpacing: '-1px'
                                    }}>
                                        {pt(tag)}
                                    </div>
                                    {index < 5 && (
                                        <div style={{
                                            width: '29px',
                                            height: '5px',
                                            backgroundImage: 'radial-gradient(circle, #d5d5d5 2px, transparent 2px)',
                                            backgroundSize: '12px 5px',
                                            backgroundRepeat: 'repeat-x',
                                            backgroundPosition: 'center',
                                            flexShrink: 0
                                        }} />
                                    )}
                                </React.Fragment>
                            ))}
                        </div>

                        {/* 특징 카드 그리드 */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                            {/* Row 1 */}
                            <div style={{ display: 'flex', gap: '26px', flexWrap: 'wrap' }}>
                                <div style={{ flex: '1', minWidth: '300px', backgroundColor: '#f5f5fb' }}>
                                    <div style={{
                                        backgroundColor: '#743fa3',
                                        color: 'white',
                                        padding: '13px 20px',
                                        textAlign: 'center',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        letterSpacing: '-1px'
                                    }}>
                                        {pt('QA_Feature1_Title')}
                                    </div>
                                    <div style={{ padding: '30px 20px', fontSize: '17px', lineHeight: '1.5', color: '#444', letterSpacing: '-1px' }}>
                                        {pt('QA_Feature1_Content').split('\n').map((line, i) => (
                                            <div key={i}>{line}</div>
                                        ))}
                                    </div>
                                </div>
                                <div style={{ flex: '1', minWidth: '300px', backgroundColor: '#f5f5fb' }}>
                                    <div style={{
                                        backgroundColor: '#743fa3',
                                        color: 'white',
                                        padding: '13px 20px',
                                        textAlign: 'center',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        letterSpacing: '-1px'
                                    }}>
                                        {pt('QA_Feature2_Title')}
                                    </div>
                                    <div style={{ padding: '30px 20px', fontSize: '17px', lineHeight: '1.5', color: '#444', letterSpacing: '-1px' }}>
                                        {pt('QA_Feature2_Content').split('\n').map((line, i) => (
                                            <div key={i}>{line}</div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* Row 2 */}
                            <div style={{ display: 'flex', gap: '26px', flexWrap: 'wrap' }}>
                                <div style={{ flex: '1', minWidth: '300px', backgroundColor: '#f5f5fb' }}>
                                    <div style={{
                                        backgroundColor: '#743fa3',
                                        color: 'white',
                                        padding: '13px 20px',
                                        textAlign: 'center',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        letterSpacing: '-1px'
                                    }}>
                                        {pt('QA_Feature3_Title')}
                                    </div>
                                    <div style={{ padding: '30px 20px', fontSize: '17px', lineHeight: '1.5', color: '#444', letterSpacing: '-1px' }}>
                                        {pt('QA_Feature3_Content').split('\n').map((line, i) => (
                                            <div key={i}>{line}</div>
                                        ))}
                                    </div>
                                </div>
                                <div style={{ flex: '1', minWidth: '300px', backgroundColor: '#f5f5fb' }}>
                                    <div style={{
                                        backgroundColor: '#743fa3',
                                        color: 'white',
                                        padding: '13px 20px',
                                        textAlign: 'center',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        letterSpacing: '-1px'
                                    }}>
                                        {pt('QA_Feature4_Title')}
                                    </div>
                                    <div style={{ padding: '30px 20px', fontSize: '17px', lineHeight: '1.5', color: '#444', letterSpacing: '-1px' }}>
                                        {pt('QA_Feature4_Content').split('\n').map((line, i) => (
                                            <div key={i}>{line}</div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* Row 3 */}
                            <div style={{ display: 'flex', gap: '26px', flexWrap: 'wrap' }}>
                                <div style={{ flex: '1', minWidth: '300px', backgroundColor: '#f5f5fb' }}>
                                    <div style={{
                                        backgroundColor: '#743fa3',
                                        color: 'white',
                                        padding: '13px 20px',
                                        textAlign: 'center',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        letterSpacing: '-1px'
                                    }}>
                                        {pt('QA_Feature5_Title')}
                                    </div>
                                    <div style={{ padding: '30px 20px', fontSize: '17px', lineHeight: '1.5', color: '#444', letterSpacing: '-1px' }}>
                                        {pt('QA_Feature5_Content').split('\n').map((line, i) => (
                                            <div key={i}>{line}</div>
                                        ))}
                                    </div>
                                </div>
                                <div style={{ flex: '1', minWidth: '300px', backgroundColor: '#f5f5fb' }}>
                                    <div style={{
                                        backgroundColor: '#743fa3',
                                        color: 'white',
                                        padding: '13px 20px',
                                        textAlign: 'center',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        letterSpacing: '-1px'
                                    }}>
                                        {pt('QA_Feature6_Title')}
                                    </div>
                                    <div style={{ padding: '30px 20px', fontSize: '17px', lineHeight: '1.5', color: '#444', letterSpacing: '-1px' }}>
                                        {pt('QA_Feature6_Content').split('\n').map((line, i) => (
                                            <div key={i}>{line}</div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section_player">
                <div className="text_box">
                    <div className="inner d_table">
                        <div className="d_cell text_primary">
                            {pt('QA_10')}
                            {/* 게임시장 성숙도에 따라, 유저가 바라는 서비스의 품질 또한
                            높아졌습니다.
                            <br />
                            10여종 이상의 Full QA를 개발사에서 모두 진행하는 것은
                            비효율적입니다.
                            <br />
                            2bytes QA팀과 최적의 QA PLAN을 확인해보세요. */}
                        </div>
                        <div className="d_cell btn_area">
                            <a
                                href={`/${i18n.language}/Contact`}
                                className="btn_basic btn_primary btn_xl btn_pop_open"
                            >
                                {pt('QA_11')}
                                {/* 문의/업무의뢰 */}
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section_discript" style={{ marginTop: '10.2rem', color: '#743fa3' }}>
                <div className="inner">
                    <strong className="title">
                        {pt('QA_FGT_Title')}
                    </strong>

                    <div className="cont" style={{ marginTop: '0px' }}>
                        <div style={{
                            display: 'flex',
                            gap: '31px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexWrap: 'wrap'
                        }}>
                            <img
                                src="/static/img/qa/ground.png"
                                alt="G.Round"
                                style={{ height: '33px', maxWidth: '100%' }}
                            />
                        </div>
                    </div>

                    <div className="step_box">
                        <dl>
                            <dt style={{ color: '#743fa3' }}>
                                {pt('QA_FGT_Partner_Title')}
                            </dt>
                            <dd style={{ color: '#743fa3' }}>
                                {pt('QA_FGT_Partner_Desc')}
                            </dd>
                        </dl>
                        <dl>
                            <dt style={{ color: '#743fa3' }}>
                                {pt('QA_FGT_Community_Title')}
                            </dt>
                            <dd style={{ color: '#743fa3' }}>
                                {pt('QA_FGT_Community_Desc')}
                            </dd>
                        </dl>
                        <dl>
                            <dt style={{ color: '#743fa3' }}>
                                {pt('QA_FGT_Insight_Title')}
                            </dt>
                            <dd style={{ color: '#743fa3' }}>
                                {pt('QA_FGT_Insight_Desc')}
                            </dd>
                        </dl>
                    </div>
                </div>
            </section>

            <section className="section_contents">
                <div className="inner">
                    <div className="h_title_box">
                        <h3 className="h_title">
                            {pt('QA_FGT_Features_Title')}
                        </h3>
                    </div>

                    <div className="cont">
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '60px' }}>
                            {/* Feature 1 - 왼쪽 텍스트, 오른쪽 일러스트 */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '40px', flexWrap: 'wrap' }}>
                                <div style={{ flex: '1', minWidth: '300px' }}>
                                    <h4 style={{
                                        color: '#743fa3',
                                        fontSize: '28px',
                                        fontWeight: 'bold',
                                        letterSpacing: '-1px',
                                        lineHeight: '36px',
                                        marginBottom: '16px'
                                    }}>
                                        {pt('QA_FGT_Feature1_Title')}
                                    </h4>
                                    <p style={{
                                        color: '#444',
                                        fontSize: '17px',
                                        lineHeight: '30px',
                                        letterSpacing: '-0.5px'
                                    }}>
                                        {pt('QA_FGT_Feature1_Desc')}
                                    </p>
                                </div>
                                <div style={{ width: '269px', height: '180px', flexShrink: 0 }}>
                                    <img 
                                        src="/static/img/qa/1.png"
                                        alt="글로벌 타겟 유저"
                                        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                    />
                                </div>
                            </div>

                            {/* Feature 2 - 왼쪽 일러스트, 오른쪽 텍스트 */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '40px', flexWrap: 'wrap-reverse' }}>
                                <div style={{ width: '198px', height: '180px', flexShrink: 0 }}>
                                    <img 
                                        src="/static/img/qa/2.png"
                                        alt="데이터 기반 리포팅"
                                        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                    />
                                </div>
                                <div style={{ flex: '1', minWidth: '300px' }}>
                                    <h4 style={{
                                        color: '#743fa3',
                                        fontSize: '28px',
                                        fontWeight: 'bold',
                                        letterSpacing: '-1px',
                                        lineHeight: '36px',
                                        marginBottom: '16px'
                                    }}>
                                        {pt('QA_FGT_Feature2_Title')}
                                    </h4>
                                    <p style={{
                                        color: '#444',
                                        fontSize: '17px',
                                        lineHeight: '30px',
                                        letterSpacing: '-0.5px'
                                    }}>
                                        {pt('QA_FGT_Feature2_Desc')}
                                    </p>
                                </div>
                            </div>

                            {/* Feature 3 - 왼쪽 텍스트, 오른쪽 일러스트 */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '40px', flexWrap: 'wrap' }}>
                                <div style={{ flex: '1', minWidth: '300px' }}>
                                    <h4 style={{
                                        color: '#743fa3',
                                        fontSize: '28px',
                                        fontWeight: 'bold',
                                        letterSpacing: '-1px',
                                        lineHeight: '36px',
                                        marginBottom: '16px'
                                    }}>
                                        {pt('QA_FGT_Feature3_Title')}
                                    </h4>
                                    <p style={{
                                        color: '#444',
                                        fontSize: '17px',
                                        lineHeight: '30px',
                                        letterSpacing: '-0.5px'
                                    }}>
                                        {pt('QA_FGT_Feature3_Desc')}
                                    </p>
                                </div>
                                <div style={{ width: '291px', height: '180px', flexShrink: 0 }}>
                                    <img 
                                        src="/static/img/qa/3.png"
                                        alt="테스터 피드백"
                                        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section_contents">
                <div className="inner">
                    <div className="h_title_box">
                        <h3 className="h_title">
                            {pt('QA_FGT_Services_Title')}
                        </h3>
                    </div>

                    <div className="cont">
                        <div style={{ display: 'flex', gap: '17px', flexWrap: 'wrap' }}>
                            <div style={{ flex: '1', minWidth: '300px', backgroundColor: '#f5f5fb' }}>
                                <div style={{
                                    backgroundColor: '#743fa3',
                                    color: 'white',
                                    padding: '13px 0',
                                    textAlign: 'center',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    letterSpacing: '-1px',
                                    lineHeight: '30px'
                                }}>
                                    {pt('QA_FGT_OPT_Title')}
                                </div>
                                <div style={{ padding: '36px 20px', fontSize: '17px', lineHeight: '26px', color: '#444', letterSpacing: '-1px', textAlign: 'center' }}>
                                    {pt('QA_FGT_OPT_Desc')}
                                </div>
                            </div>

                            <div style={{ flex: '1', minWidth: '300px', backgroundColor: '#f5f5fb' }}>
                                <div style={{
                                    backgroundColor: '#743fa3',
                                    color: 'white',
                                    padding: '13px 0',
                                    textAlign: 'center',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    letterSpacing: '-1px',
                                    lineHeight: '30px'
                                }}>
                                    {pt('QA_FGT_FGT_Title')}
                                </div>
                                <div style={{ padding: '36px 20px', fontSize: '17px', lineHeight: '26px', color: '#444', letterSpacing: '-1px', textAlign: 'center' }}>
                                    {pt('QA_FGT_FGT_Desc')}
                                </div>
                            </div>

                            <div style={{ flex: '1', minWidth: '300px', backgroundColor: '#f5f5fb' }}>
                                <div style={{
                                    backgroundColor: '#743fa3',
                                    color: 'white',
                                    padding: '13px 0',
                                    textAlign: 'center',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    letterSpacing: '-1px',
                                    lineHeight: '30px'
                                }}>
                                    {pt('QA_FGT_CBT_Title')}
                                </div>
                                <div style={{ padding: '36px 20px', fontSize: '17px', lineHeight: '26px', color: '#444', letterSpacing: '-1px', textAlign: 'center' }}>
                                    {pt('QA_FGT_CBT_Desc')}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section_player">
                <div className="text_box">
                    <div className="inner d_table">
                        <div className="d_cell text_primary">
                            {pt('QA_FGT_Bottom_Text')}
                        </div>
                        <div className="d_cell btn_area">
                            <a
                                href={`/${i18n.language}/Contact`}
                                className="btn_basic btn_primary btn_xl btn_pop_open"
                            >
                                {pt('QA_11')}
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

function Qa(props) {
    return (
        <div id="container" className="cont_qa">
            <SectionTop title="Quality Assurance" mtitle="QA" />
            <Content />
            <Services />
            <SectionBottom />
        </div>
    );
}

export default Qa;
